import { render, staticRenderFns } from "./TgQrcodeBtn.vue?vue&type=template&id=5d909b40"
import script from "./TgQrcodeBtn.vue?vue&type=script&lang=js"
export * from "./TgQrcodeBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports